<!--
 * @Author: your name
 * @Date: 2021-09-17 14:31:54
 * @LastEditTime: 2026-07-29 16:51:55
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\login\Register.vue
-->
<template>
  <div class="register">
    <div class="title flex-c-c">{{ $t('clr1') }}</div>
    <div class="user-form">
      <el-form :model="user" :rules="rules" ref="userForm" label-width="200px">
        <el-form-item :label="$t('clr2')" prop="user_name" :error="error.user_name">
          <el-input v-model="user.user_name" @change="(val) => verification('user_name', val)"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone" :error="error.phone">
          <el-input type="tel" v-model="user.phone" @change="(val) => verification('phone', val)"></el-input>
        </el-form-item>
        <!-- :error="error.email" -->
        <el-form-item :label="$t('clr5')" prop="email">
          <el-input type="email" v-model="user.email" @change="(val) => { if (val) verification('email', val) }"></el-input>
        </el-form-item>

        <el-form-item prop="email_code" :label="$t('clr6')">
          <div class="flex-b-c">
            <el-input v-model="user.email_code" autocomplete="off">
              <template slot="append">
                <span @click="user.vtype ? getVerification() : getPhoneCode()"
                  :class="{ 'email-code': error.email_code }" class="email-code-hover" style="user-select: none;"
                  v-if="codeTime <= 0">{{ user.vtype ? "获取邮箱验证码" : "获取手机验证码"
                  }}</span>
                <span class="email-code" style="user-select: none; max-width: 110px; text-align: center;"
                  v-if="codeTime > 0">{{ codeTime }}{{ $t('clr8') }}</span>
              </template>
            </el-input>
            <el-button type="primary" style="width: 126px;margin-left: 16px;" @click="() => {
              user.vtype = !user.vtype; codeTime = 0;
            }" round>{{ user.vtype ? '切换手机验证' : '切换邮箱验证' }}</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('clr9')" prop="password">
          <el-input v-model="user.password" type="password" auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clr10')" prop="rpassword">
          <el-input v-model="user.rpassword" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clr11')" prop="group_name">
          <div class="flex-c-c">
            <el-input v-model="user.group_name"></el-input>
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">{{ $t('nlR04') }}</div>
              <i class="el-icon-question" style="font-size: 20px; margin-left: 2px;"></i>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="企业地址" style="margin-bottom: 18px;">
          <div style="display: flex; justify-content: space-between; width: 100%;">
            <div style="flex: 1; margin-right: 12px;">
              <el-cascader placeholder="请选择企业地址" v-model="user.remark2" :options="citys" @change="cityChange"
                style="width: 100%;"></el-cascader>
              <div v-if="error.remark2"
                style="color: #f56c6c; font-size: 12px; line-height: 14px; min-height: 14px; margin-top: 2px;">{{
                  error.remark2
                }}</div>
            </div>
            <div style="flex: 1;">
              <el-input v-model="user.remark2_1" placeholder="请输入详细地址" @input="() => { error.remark2_1 = '' }"
                style="width: 100%;"></el-input>
              <div v-if="error.remark2_1"
                style="color: #f56c6c; font-size: 12px; line-height: 14px; min-height: 14px; margin-top: 2px;">{{
                  error.remark2_1 }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 0;">
          <div>
            <el-checkbox v-model="user.serviceContract" @change="() => { error.serviceContract = '' }"></el-checkbox>
            同意<a style="color:#409EFF" class="icon" href="https://aiot.qlled.com:9999/agreement/ToS.htm"
              target="_blank">服务协议</a>和<a style="color:#409EFF" class="icon"
              href="https://aiot.qlled.com:9999/agreement/PP.htm" target="_blank">隐私协议</a>
          </div>
          <div v-if="error.serviceContract" style="color: #f56c6c; font-size: 12px; line-height: 14px;">{{
            error.serviceContract
          }}</div>
        </el-form-item>
        <el-form-item label-width="50px">
          <el-button type="primary" @click="submitForm('userForm')" round>{{ $t('clr12') }}</el-button>
        </el-form-item>
        <el-form-item label-width="30px">
          <div @click="setShowType" class="re-login">
            <span>{{ $t('clr13') }}?</span>&nbsp;
            <span style="color: #606266;">{{ $t('clr14') }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// admin/signin/isLegal
// admin/signin/getEmailCode
import citys from '@static/data/city.json';
import isPasswordValid from '@/assets/scripts/isPasswordValid.js'
export default {
  name: "Register",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr15')));
      } else if (value !== this.user.password) {
        this.user.rpassword = "";
        callback(new Error(this.$t('clr16')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('nlR01')));
        } else if (!isPasswordValid(value)) {
          callback(new Error("密码至少8位至少需要包含字母数字特殊符号其中2种"));
      } else {
        callback();
      }
    };
    let groupName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr22')));
      } else if ((value.length < 2) || (!isNaN(Number(value)))) {
        callback(new Error(this.$t('nlR03')));
      } else {
        callback();
      }
    };
    return {
      citys,
      codeTime: 0,
      intervalTime: null,
      error: {
        email: "",
        user_name: "",
        email_code: true,
        phone: '',
        remark2: '',
        remark2_1: '',
        serviceContract: ''
      },
      user: {
        user_name: "",
        email_code: "",
        email: "",
        password: "",
        rpassword: "",
        group_name: "",
        serviceContract: false,
        phone: '',
        vtype: false,
        remark2: '',
        remark2Info: '',
        remark2_1: ''
      },
      rules: {
        user_name: [{ required: true, validator: this.checkUserName, trigger: 'blur' }],
        email_code: [{ required: true, message: this.$t('clr19'), trigger: 'change' }],
        email: [{ type: 'email', required: false, message: this.$t('clr20'), trigger: 'blur' }],
        phone: [{ required: true, pattern: /^1[3-9]\d{9}$/, message: this.$t('clr25'), trigger: 'blur' }],
        password: [{ required: true, validator: passStrength, trigger: 'blur' }],
        rpassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        // group_name: [{ required: true, message: this.$t('clr22'), trigger: 'blur' }],
        group_name: [{ required: true, validator: groupName, trigger: 'blur' }],
        remark2: [{ required: true, message: this.$t('clr26'), trigger: 'change' }],
        remark2_1: [{ required: true, message: this.$t('clr27'), trigger: 'blur' }],
      }
    }
  },
  methods: {
    // 账户验证
    async checkUserName(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('csum37')));
      }
      let regexp = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/;
      if (!regexp.test(value)) {
        callback(new Error(this.$t('csum38')));
      }
      if (value.length < 2 || value.length > 20) {
        callback(new Error(this.$t('csum39')));
      }
      // if (await this.accountVerification()) {
      //   callback(new Error(this.$t('csum40')));
      // }
      callback();
    },
    cityChange(citykey) {
      this.error.remark2 = '';
      let city1 = this.citys.find((time) => time.value === citykey[0]);
      let city2 = city1.children.find((time) => time.value === citykey[1])
      this.user.remark2Info = city1.label + city2.label;
    },
    setShowType() {
      this.$emit("setShowType");
    },
    // referralLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'referral_code', value: val }, res => {
    //     if (!res) {
    //       this.errorAuthCode = "推荐码不存在，请重新获取。";
    //     } else {
    //       this.errorAuthCode = "";
    //     }
    //   });
    // },
    // userNameLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'email', value: val }, res => {
    //     if (!res) {
    //       this.errorUserName = "用户名已注册，请重新输入!";
    //     } else {
    //       this.errorUserName = "";
    //     }
    //   });
    // },
    // userEmailLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'user_name', value: val }, res => {
    //     if (!res) {
    //       this.errorUserName = "用户名已注册，请重新输入!";
    //     } else {
    //       this.errorUserName = "";
    //     }
    //   });
    // },
    verification(key, value) {
      this.$http.post("/admin/signin/isLegal", { key, value }, res => {
        console.log(res);
        if (res.status) {
          this.error[key] = res.tips;
        } else {
          this.error[key] = "";
          (key === 'email' || key === 'phone') && (this.error.email_code = false);
        }
      });
    },
    getPhoneCode() {
      if (!this.user.phone) {
        this.$msg({ message: this.$t('clr25'), type: "error", showClose: true });
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.user.phone)) {
        this.$msg({ message: this.$t('clr25'), type: "error", showClose: true });
        return;
      }
      if (this.error.phone) {
        this.$msg({ message: this.error.phone, type: "error", showClose: true });
        return;
      }
      this.codeTime = 120;
      this.$http.post("/admin/signin/getPhoneCode", {
        phone: this.user.phone,
        timeout: 300,
        type: 1
      }, () => {
        this.$msg({ message: this.$t('clr23'), type: "success", showClose: true });
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    getVerification() {
      if (!this.user.email) {
        this.$msg({ message: this.$t('clr20'), type: "error", showClose: true });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.user.email)) {
        this.$msg({ message: this.$t('clr20'), type: "error", showClose: true });
        return;
      }
      if (this.error.email) {
        this.$msg({ message: this.error.email, type: "error", showClose: true });
        return;
      }
      this.codeTime = 120;
      this.$http.post("/admin/signin/getEmailCode", {
        recipients: this.user.email,
        timeout: 300
      }, () => {
        this.$msg({ message: this.$t('clr23'), type: "success", showClose: true });
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    //   user_name: this.addForm.name,
    // referral_code: this.addForm.authCode,
    // email: this.addForm.email,
    // pwd: encodeURIComponent(JSON.stringify([this.addForm.pass, this.addForm.checkPass])),
    // group_name: this.addForm.grouping,
    // email_code: this.addForm.verificationCode
    submitForm(formName) {
      this.error.remark2 = '';
      this.error.remark2_1 = '';
      this.error.serviceContract = '';
      // if (!this.user.remark2) {
      //   this.error.remark2 = this.$t('clr26');
      // }
      // if (!this.user.remark2_1) {
      //   this.error.remark2_1 = this.$t('clr27');
      // }
      if (!this.user.serviceContract) {
        this.error.serviceContract = this.$t('clr24');
      }
      // && !this.error.remark2 && !this.error.remark2_1
      this.$refs[formName].validate((valid) => {
        if (valid && !this.error.serviceContract) {
          let { user_name, email, group_name, email_code, phone, vtype, remark2Info, remark2_1 } = this.user;
          let pwd = encodeURIComponent(JSON.stringify([this.user.password, this.user.rpassword]));
          this.$http.post("/admin/signin/signIn", {
            user_name,
            email,
            pwd,
            group_name,
            email_code,
            phone,
            vtype: vtype ? 1 : 0,
            isReferral: 0,
            remark2: remark2Info + remark2_1
          }, (res) => {
            const { status, tips } = res;
            if (status !== 1 && status !== undefined) {
              this.$msg({ message: tips, type: "error", showClose: true });
              return;
            }
            this.$msg({ message: "账号注册成功!", type: "success", showClose: true });
            this.setShowType();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    isVerifin() {
      return this.error.email && this.error.user_name;
    }
  },
}
</script>

<style lang="scss" scoped>
.register {
  background-color: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;

  .title {
    height: 50px;
    font-size: 20px;
    color: #fff;
    // background-image: linear-gradient(270deg,
    //     #86eae7 0%,
    //     #4cccf0 45%,
    //     #11adf8 100%),
    //   linear-gradient(#ffffff, #ffffff);
    // background-blend-mode: normal, normal;
    background-color: var(--theme-color-customized-1);
  }

  .user-form {
    padding-right: 30px;
    padding-top: 20px;
    background-color: #fff;

    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      background-color: var(--theme-color-customized-1);
      color: #fff;
    }

    .el-form-item+.el-form-item {
      margin-top: 20px;
    }

    /deep/ .el-input-group__append {
      border-radius: 0px 20px 20px 0px;
      padding: 0 6px;
      text-align: center;
      width: 100px;
    }

    .re-login {
      text-align: center;
      line-height: 10px;
      cursor: pointer;
    }

    .email-code {
      cursor: not-allowed;
    }

    .email-code-hover {
      cursor: pointer;
    }
  }
}
</style>